export default "__VITE_ASSET__456b34e5__"